import React from 'react';

import html from '../assets/img/skill/html5.png';
import css from '../assets/img/skill/css3.png';
import bootstrap from '../assets/img/skill/bootstrap.png';
import js from '../assets/img/skill/javascript.png';
import ajax from '../assets/img/skill/ajax.png';
import jquery from '../assets/img/skill/jquery.png';
import php from '../assets/img/skill/php.png';
import mysql from '../assets/img/skill/mysql.png';
import git from '../assets/img/skill/git.png';
import laravel from '../assets/img/skill/laravel.png';
import codeigniter from '../assets/img/skill/codeigniter.png';
import wp from '../assets/img/skill/wp.png';
import api from '../assets/img/skill/api.png';
import react from '../assets/img/skill/reactjs.png';

const Skill = () => {
    return (
        <>
            {/* Services Section */}
            <section id="services" className="services section">
                {/* Section Title */}
                <div className="container section-title" data-aos="fade-up">
                    <h2><i className="bi bi-hdd-stack navicon"></i> Keterampilan</h2>
                </div>
                {/* End Section Title */}
                <div className="container">
                    <div className="row gy-4">
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={html} alt='html5' style={{ maxHeight: "125px" }} />

                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={css} alt='css3' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}

                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={bootstrap} alt='bootstrap' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}

                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={js} alt='javascript' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                    </div>

                    <div className="row gy-4">
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={jquery} alt='jquery' style={{ maxHeight: "125px" }} />

                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={ajax} alt='ajax' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}

                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={react} alt='react js' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}

                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={php} alt='php' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                    </div>


                    <div className="row gy-4">
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={mysql} alt='mysql' style={{ maxHeight: "125px" }} />

                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={git} alt='git' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}

                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={laravel} alt='laravel' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}

                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={codeigniter} alt='codeigniter' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                    </div>

                    <div className="row gy-4">
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={wp} alt='wordpress' style={{ maxHeight: "125px" }} />

                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                        {/* End Service Item */}
                        <div
                            className="col-lg-3 col-md-6 service-item d-flex"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <div className="flex-shrink-0" style={{ width: "54px", marginLeft: "40px" }}>
                            </div>
                            <div>
                                <h4 className="title">
                                </h4>
                                <p className="description">
                                    <img src={api} alt='rest full api' style={{ maxHeight: "125px" }} />
                                </p>
                            </div>
                        </div>
                        {/* End Service Item */}
                    </div>
                </div>
            </section>
            {/* /Services Section */}
        </>
    )
}

export default Skill;